import get from 'lodash.get';
import placeholderImage from '@/assets/placeholder.png';
import { isUndefinedOrNullOrEmpty } from '@/utilities';
import BaseAuction from './BaseAuction';

export default class RunListAuction extends BaseAuction {
  constructor(runListAuction) {
    super(runListAuction);
    this.auction = runListAuction;

    // Match the proxy prop to the single auction get name(current_proxy -> proxy_bid)
    if (this.auction.current_proxy) {
      this.auction.proxy_bid = this.auction.current_proxy;
      delete this.auction.current_proxy;
    }
  }

  get alert() {
    return get(this.auction, 'alert', '');
  }

  get alertMessage() {
    return get(this.auction, 'alert_message', '');
  }

  get currentProxyFormatted() {
    return get(this, 'proxyBid.formatted');
  }

  get primaryImageMedium() {
    return get(this.auction, 'thumbnail', this.placeholderImage);
  }

  get groupBy() {
    return get(this.auction, 'group_by');
  }

  get price() {
    return get(this.auction, 'price', {});
  }

  get priceFormatted() {
    return get(this, 'price.formatted');
  }

  get startPrice() {
    return get(this, 'price.raw');
  }

  get subtitle() {
    return get(this.auction, 'subtitle', '');
  }

  // TODO - Object instead? - ETC
  get thumbnail() {
    return get(this.auction, 'thumbnail', placeholderImage);
  }

  get title() {
    return get(this.auction, 'title', '');
  }

  get userHasExistingRunListProxy() {
    return !isUndefinedOrNullOrEmpty(this.proxyBid);
  }
}
